import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconArticle } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface PublicationListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const PublicationListItem: React.FC<PublicationListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconArticle}
    typeLabel="Publication"
    testId="publication-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.READ }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default PublicationListItem
